$(document).ready(function () {
  $(document).on('submit', 'form', function (e) {
    const $form = $(this);

    // Tìm checkbox có yêu cầu confirm popup khi submit
    const $checkbox = $form.find('.js-checkbox-require-confirm-submit');

    if ($checkbox.length && $checkbox.is(':checked')) {
      // Lấy message từ data-confirm-message
      const message = $checkbox.data('confirm-message') || 
                      "Bạn chắc chắn muốn thay đổi?";

      const isConfirmed = confirm(message);

      if (!isConfirmed) {
        e.preventDefault();
        // Nếu button bị disable bởi Rails UJS (data-disable-with), cần enable lại nó:
        // $form.find('input[type="submit"], button[type="submit"]').prop('disabled', false);
        var $submitBtn = $form.find('input[type="submit"], button[type="submit"]');
        setTimeout(function(){ $submitBtn.prop('disabled', false); }, 100);
        return false;
      }
    }
  });
});
